import { InfoIcon } from "@components/SsnDisclaimer/InfoIcon";
import { Caption } from "@components/Typography";
import { Translations, i18n } from "@i18n";
import { useStyles } from "./styles";
import { AssetRangeDisclaimerProps } from "./types";

export const AssetRangeDisclaimer = ({ style }: AssetRangeDisclaimerProps) => {
  const styles = useStyles();

  return (
    <div style={{ ...styles.container, ...style }}>
      <InfoIcon />
      <div style={styles.content}>
        <Caption style={styles.title}>
          {i18n.t(Translations.AssetRangeRouteDisclaimerTitle)}
        </Caption>
        <Caption style={styles.subtitle}>
          {i18n.t(Translations.AssetRangeRouteDisclaimerSubtitle)}
        </Caption>
      </div>
    </div>
  );
};
